import { SproToasterService } from "../../../sproLib/spro/services/spro-toaster/spro-toaster.service";
import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-pageProfilContact",
  styleUrls: ["./pageProfilContact.component.scss"],
  templateUrl: "./pageProfilContact.component.html"
})
export class cls_profilContact {
  /* ###########################################  VARIABLES  #######################################################*/

  /** Nom de la page afin de gérer la traduction */
  public w_titre_trad = "pageProfilContact.";
  /** Flag de chargement */
  public f_loading: boolean = true;

  /** Mode Profil ou Register */
  public f_modeProfil: boolean = true;
  /** Masquer le libellé de titre Etape */
  public f_masqueEtape: boolean = false;

  /** Formulaire des données */
  public form_profil: FormGroup = new FormGroup({
    nominterloc: new FormControl("", [
      Validators.required,
      Validators.maxLength(100)
    ]),
    foncinterloc: new FormControl("", Validators.maxLength(45)),
    emailinterloc: new FormControl(
      "",
      Validators.compose([
        Validators.required,
        Validators.email,
        Validators.maxLength(100)
      ])
    ),
    emailinterloc2: new FormControl(
      "",
      Validators.compose([
        Validators.nullValidator,
        Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$"),
        Validators.maxLength(100)
      ])
    ),
    portableinterloc: new FormControl("", Validators.maxLength(30))
  });

  /* ###########################################  CONSTRUCTEUR  ####################################################*/

  /**
   * Constructeur
   */
  constructor(public s_toaster: SproToasterService) {}

  /* ###########################################  FONCTIONS  #######################################################*/

  /**
   * Affectation des valeurs
   */
  public proc_setData(
    f_modeProfil: boolean,
    h_data: any,
    f_masqueEtape: boolean
  ): void {
    this.f_modeProfil = f_modeProfil;

    if (h_data == null) this.form_profil.reset([]);
    else this.form_profil.reset(h_data);

    this.f_masqueEtape = f_masqueEtape;

    this.f_loading = false;
  }

  /**
   * Test du formulaire et retourne les valeurs
   */
  public proc_getData(): any {
    //Verifications de la validité des Validators (format /required)
    if (this.form_profil.status === "INVALID") {
      this.s_toaster.proc_toastTradError("pageProfil.msg_FormInval");
      return null;
    }

    //Verifications de la confirmation mail
    if (
      !this.f_modeProfil &&
      this.form_profil.controls.emailinterloc.value !==
        this.form_profil.controls.emailinterloc2.value
    ) {
      this.s_toaster.proc_toastTradError(this.w_titre_trad + "msg_mailDiff");
      return null;
    }

    return this.form_profil.value;
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/shared/components/pageProfilContact/pageProfilContact.component.ts